"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CURRENT_USER_PREFIX = exports.ENVIRONMENT_VARIABLE_PREFIX = exports.CURRENT_USER_DERIVED_FIELDS_PREFIX = exports.PROJECT_CONSTANTS_PREFIX = exports.COLLECTION_CONSTANTS_PREFIX = exports.DERIVED_FIELDS_PREFIX = exports.REFERENCE_FIELDS_PREFIX = exports.COOKIES = exports.LOCAL_STORAGE = exports.SESSION_STORAGE = exports.FORM_DATA_SESSION = exports.ENVIRONMENT_VARIABLE = exports.PROJECT_CONSTANTS = exports.COLLECTION_CONSTANTS = exports.DERIVED_FIELDS = exports.REFERENCE_FIELDS = exports.CURRENT_SUB_TENANT_LOWER = exports.CURRENT_SETTINGS_LOWER = exports.CURRENT_TENANT_LOWER = exports.CURRENT_USER_LOWER = exports.CURRENT_SESSION = exports.OAUTH2 = exports.AURORA = exports.MARIADB = exports.ORACLEDB = exports.MS_SQL_SERVER = exports.SQLITE = exports.MYSQL = exports.POSTGRESQL = exports.TOOLTIP_TEMPLATE = exports.SMS_TEMPLATE = exports.EMAIL_TEMPLATE = exports.DRAPCODE = exports.APP_WRITE = exports.NOTION = exports.APPWRITE = exports.SUPABASE = exports.XANO = exports.MAKE = exports.INTEGROMAT = exports.CHAT_GPT = exports.ZAPIER = exports.FIREBASE_FUNCTION = exports.FIREBASE_CLOUD_FIRESTORE = exports.FIREBASE_REALTIME_DATABASE = exports.AIRTABLE = exports.GOOGLE_SHEET = exports.DATABASE = exports.REST_API = exports.REST_API_PRIMAREY_KEY = void 0;
exports.fieldsKeyPrefixMap = exports.fieldsPrefixForDF = exports.dataSourcePrimaryKeys = exports.API_TYPES2 = exports.API_TYPES = exports.SOCKET_IO_TEMPLATE = exports.TYPESENSE_SEARCH_TEMPLATE = exports.AGREEMENT_TEMPLATE = exports.COLLECTION_SNAPSHOT = exports.SALESFORCE = exports.DIRECTUS = exports.XATA = exports.CURRENT_USER_REFERENCE_FIELDS_PREFIX = void 0;
exports.REST_API_PRIMAREY_KEY = "_data_source_rest_api_primary_id";
exports.REST_API = "REST_API";
exports.DATABASE = "DATABASE";
exports.GOOGLE_SHEET = "GOOGLE_SHEET";
exports.AIRTABLE = "AIRTABLE";
exports.FIREBASE_REALTIME_DATABASE = "FIREBASE_REALTIME_DATABASE";
exports.FIREBASE_CLOUD_FIRESTORE = "FIREBASE_CLOUD_FIRESTORE";
exports.FIREBASE_FUNCTION = "FIREBASE_FUNCTION";
exports.ZAPIER = "ZAPIER";
exports.CHAT_GPT = "CHAT_GPT";
exports.INTEGROMAT = "INTEGROMAT";
exports.MAKE = "MAKE";
exports.XANO = "XANO";
exports.SUPABASE = "SUPABASE";
exports.APPWRITE = "APPWRITE";
exports.NOTION = "NOTION";
exports.APP_WRITE = "APP_WRITE";
exports.DRAPCODE = "DRAPCODE";
exports.EMAIL_TEMPLATE = "EMAIL_TEMPLATE";
exports.SMS_TEMPLATE = "SMS_TEMPLATE";
exports.TOOLTIP_TEMPLATE = "TOOLTIP_TEMPLATE";
exports.POSTGRESQL = "POSTGRESQL";
exports.MYSQL = "MYSQL";
exports.SQLITE = "SQLITE";
exports.MS_SQL_SERVER = "MS_SQL_SERVER";
exports.ORACLEDB = "ORACLEDB";
exports.MARIADB = "MARIADB";
exports.AURORA = "AURORA";
exports.OAUTH2 = "OAUTH2.0";
exports.CURRENT_SESSION = "current_session";
exports.CURRENT_USER_LOWER = "current_user";
exports.CURRENT_TENANT_LOWER = "current_tenant";
exports.CURRENT_SETTINGS_LOWER = "current_settings";
exports.CURRENT_SUB_TENANT_LOWER = "current_sub_tenant";
exports.REFERENCE_FIELDS = "reference_fields";
exports.DERIVED_FIELDS = "derived_fields";
exports.COLLECTION_CONSTANTS = "collection_constants";
exports.PROJECT_CONSTANTS = "project_constants";
exports.ENVIRONMENT_VARIABLE = "environment_variable";
exports.FORM_DATA_SESSION = "form_data_session";
exports.SESSION_STORAGE = "SESSION_STORAGE";
exports.LOCAL_STORAGE = "LOCAL_STORAGE";
exports.COOKIES = "COOKIES";
exports.REFERENCE_FIELDS_PREFIX = "RF::";
exports.DERIVED_FIELDS_PREFIX = "DF::";
exports.COLLECTION_CONSTANTS_PREFIX = "CC::";
exports.PROJECT_CONSTANTS_PREFIX = "PC::";
exports.CURRENT_USER_DERIVED_FIELDS_PREFIX = "current_user.DF::";
exports.ENVIRONMENT_VARIABLE_PREFIX = "environment_variable.";
exports.CURRENT_USER_PREFIX = "current_user.";
exports.CURRENT_USER_REFERENCE_FIELDS_PREFIX = "current_user_reference_field.";
exports.XATA = "XATA";
exports.DIRECTUS = "DIRECTUS";
exports.SALESFORCE = "SALESFORCE";
exports.COLLECTION_SNAPSHOT = "COLLECTION_SNAPSHOT";
exports.AGREEMENT_TEMPLATE = "AGREEMENT_TEMPLATE";
exports.TYPESENSE_SEARCH_TEMPLATE = "TYPESENSE_SEARCH_TEMPLATE";
exports.SOCKET_IO_TEMPLATE = "SOCKET_IO_TEMPLATE";
exports.API_TYPES = [exports.REST_API, exports.DATABASE, exports.GOOGLE_SHEET, exports.AIRTABLE, exports.FIREBASE_REALTIME_DATABASE, exports.FIREBASE_CLOUD_FIRESTORE, exports.FIREBASE_FUNCTION, exports.ZAPIER, exports.MAKE, exports.XANO, exports.SUPABASE, exports.APP_WRITE, exports.NOTION, exports.CHAT_GPT, exports.XATA, exports.DIRECTUS, exports.SALESFORCE];
exports.API_TYPES2 = [exports.REST_API, exports.DATABASE, exports.GOOGLE_SHEET, exports.AIRTABLE, exports.FIREBASE_REALTIME_DATABASE, exports.FIREBASE_CLOUD_FIRESTORE, exports.FIREBASE_FUNCTION, exports.CHAT_GPT];
exports.dataSourcePrimaryKeys = [exports.REST_API_PRIMAREY_KEY];
exports.fieldsPrefixForDF = [exports.CURRENT_USER_PREFIX, exports.CURRENT_USER_REFERENCE_FIELDS_PREFIX, exports.ENVIRONMENT_VARIABLE_PREFIX, exports.COLLECTION_CONSTANTS_PREFIX, exports.PROJECT_CONSTANTS_PREFIX, exports.REFERENCE_FIELDS_PREFIX];
exports.fieldsKeyPrefixMap = [{
  key: exports.CURRENT_USER_LOWER,
  prefix: exports.CURRENT_USER_LOWER
}, {
  key: exports.CURRENT_SESSION,
  prefix: exports.CURRENT_SESSION
}, {
  key: exports.ENVIRONMENT_VARIABLE,
  prefix: exports.ENVIRONMENT_VARIABLE
}, {
  key: exports.REFERENCE_FIELDS,
  prefix: exports.REFERENCE_FIELDS_PREFIX
}, {
  key: exports.DERIVED_FIELDS,
  prefix: exports.DERIVED_FIELDS_PREFIX
}, {
  key: exports.COLLECTION_CONSTANTS,
  prefix: exports.COLLECTION_CONSTANTS_PREFIX
}, {
  key: exports.PROJECT_CONSTANTS,
  prefix: exports.PROJECT_CONSTANTS_PREFIX
}];